export default __webpack_public_path__ + "static/media/clinica-adventista.d028cf1b.svg";